module.exports = "<p-confirmDialog header=\"Confirmação\" acceptLabel=\"Sim\" rejectLabel=\"Não\"  width=\"425\"></p-confirmDialog>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main